const addToSet = (set, value) => {
  return new Set([...set, value]);
};

const removeFromSet = (set, value) => {
  const newArray = [...set].filter((v) => v != value);

  return new Set(newArray);
};

export default {
  state: {
    pendingSubmissions: new Set(),
  },
  mutations: {
    markFormPendingSubmission(state, formName) {
      state.pendingSubmissions = addToSet(state.pendingSubmissions, formName);
    },
    clearFormPendingSubmission(state, formName) {
      state.pendingSubmissions = removeFromSet(
        state.pendingSubmissions,
        formName
      );
    },
    resetFormPendingSubmissions(state) {
      state.pendingSubmissions = new Set();
    },
  },
  getters: {
    hasPendingSubmissions(state) {
      return state.pendingSubmissions.size > 0;
    },
    formattedPendingSubmissionsList({ pendingSubmissions }) {
      const items = [...pendingSubmissions];
      const count = items.length;

      if (count === 0) return "";
      if (count === 1) return items[0];

      const firstItems = items.slice(0, count - 1);
      const lastItem = items[count - 1];

      return firstItems.join(", ") + ` e ${lastItem}`;
    },
  },
};
